import cn from 'classnames'
import { type CSSProperties, type ReactNode } from 'react'

import { SectionLoading } from './SectionLoading'

import styles from './SectionLoadingFrame.module.scss'

interface ISectionLoadingFrameProps {
  /** True while the content loads: the content is not drawn and the loading state covers its room. */
  show: boolean
  /** The room held while it loads; once loaded, the content takes its own height. */
  minHeight: CSSProperties['minHeight']
  name?: string
  className?: string
  children?: ReactNode
}

/**
 * `SectionLoading` for an area that draws nothing until its data is in: it holds the room it is
 * given while it loads, then the content takes its own height and the loading state fades away.
 */
export const SectionLoadingFrame = ({
  show,
  minHeight,
  name,
  className,
  children,
}: ISectionLoadingFrameProps) => (
  <div className={cn(styles.root, className)}>
    {show ? <div style={{ minHeight }} /> : children}
    <SectionLoading show={show} name={name} />
  </div>
)

SectionLoadingFrame.displayName = 'SectionLoadingFrame'
